import {
  CUSTOMER_ADD,
  CUSTOMER_DATA,
  CUSTOMER_ADD_LOADER,
  CUSTOMER_TOGGLE_ACTIVE,
  CUSTOMER_DELETED,
  CUSTOMER_EDIT,
  CUSTOMER_SERVER_DATA,
  CUSTOMER_RESET_SUCCESS,
} from "../actions/types";

const DEFAULT_STATE = {
  isSucess: false,
  customerData: [],
  activeCustomerData: [],
  isShowLoader: false,
  customerServers: [],
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CUSTOMER_ADD:
      return {
        ...state,
        isSuccess: action.payload.success,
        errorMessage: action.payload.message,
        isShowLoader: false,
      };
    case CUSTOMER_ADD_LOADER:
      return {
        ...state,
        isShowLoader: action.payload,
      };
    case CUSTOMER_DATA:
      return {
        ...state,
        customerData: action.payload,
        activeCustomerData: action.payload
          ? action.payload.filter((c) => c.active === 1)
          : [],
        isShowLoader: false,
        isSuccess: false,
        errorMessage: "",
      };
    case CUSTOMER_TOGGLE_ACTIVE:
      return {
        ...state,
        isShowLoader: false,
        customerData: state.customerData.map((customer) =>
          customer.customer_id === action.payload.customerId
            ? {
                ...customer,
                active: action.payload.newStatus,
              }
            : customer
        ),
      };
    case CUSTOMER_DELETED:
      return {
        ...state,
        isShowLoader: false,
        customerData: state.customerData.filter(
          (customer) => customer.customer_id !== action.payload.customerId
        ),
      };
    case CUSTOMER_EDIT:
      return {
        ...state,
        isSuccess: action.payload.success,
        errorMessage: action.payload.message,
        isShowLoader: false,
      };
    case CUSTOMER_SERVER_DATA:
      return {
        ...state,
        customerServers: action.payload,
        errorMessage: "",
        isSuccess: false,
        isShowLoader: false,
      };
    case CUSTOMER_RESET_SUCCESS:
      return {
        ...state,
        isSuccess: false,
        errorMessage: "",
      };
    default:
      return state;
  }
};
